import { createActions, createState, createReducer } from 'reduxsauce-crud'


export const CenterProductsRedux = createActions(
  {},
  {
    prefix: 'CENTER_PRODUCTS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = CenterProductsRedux
export const CenterProductsTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

export const reducer = createReducer(
  INITIAL_STATE, {},
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/CenterProductsRedux.js